import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { SECTION } from "@/constants/testIds";
import { useI18n } from "@/i18n/I18nContext";

export default function Testimonials() {
  const { t } = useI18n();
  const tt = t.testimonials;

  return (
    <section data-testid={SECTION.testimonials} className="section-y bg-slate-50/70">
      <div className="container-x">
        <div className="max-w-3xl">
          <span className="text-overline">{tt.overline}</span>
          <h2 className="mt-4 font-display font-semibold text-navy text-3xl sm:text-4xl lg:text-5xl leading-[1.1]">
            {tt.title}
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {tt.list.map((it, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`testimonial-${i}`}
              className="p-8 rounded-2xl bg-white border border-slate-200 hover:shadow-lg transition-shadow relative"
            >
              <Quote className="absolute top-6 right-6 h-7 w-7 text-cyan-100" />
              <blockquote className="font-display text-lg leading-relaxed text-navy">
                « {it.quote} »
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-slate-100">
                <div className="text-sm font-medium text-navy">{it.author}</div>
                <div className="text-xs text-slate-500">{it.company}</div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
